import React, { createContext, useState, useContext, useEffect } from 'react'
import NewsletterModal from '../components/organisms/Modals/NewsletterModal/NewsletterModal'

const defaultValues = {
  showAdditionalMenu: false,
  setShowAdditionalMenu: () => {},
}

const AppWrappedContext = createContext(defaultValues)

export const useAppWrapped = () => useContext(AppWrappedContext)

export function AppWrappedProvider({ children }) {
  const [showAdditionalMenu, setShowAdditionalMenu] = useState(false)

  return (
    <AppWrappedContext.Provider value={{ showAdditionalMenu, setShowAdditionalMenu }}>
      <NewsletterModal />
      {children}
    </AppWrappedContext.Provider>
  )
}
